import { FormEvent, useMemo, useState } from "react";

import { SelectData } from "../../../../../../models";

interface UseSelectDealsModalReturnData {
  dealsMultiSelectDataOrder: string[];
  open: boolean;
  onDropdownVisibleChange: (open: boolean) => void;
  closePanelAndDropdown: () => void;
  saveDealsSelectDataAndCloseDropdown: (e: FormEvent<HTMLFormElement>) => void;
}

interface UseSelectDealsModalProps {
  roadmapDealUuids: string[];
  dealsMultiSelectData: SelectData | undefined;
  closePanel: () => void;
  onSaveDealsSelectData: () => void;
}

export const useSelectDealsModal = ({
  roadmapDealUuids,
  dealsMultiSelectData,
  closePanel,
  onSaveDealsSelectData,
}: UseSelectDealsModalProps): UseSelectDealsModalReturnData => {
  const [open, setOpen] = useState(false);

  const onDropdownVisibleChange = (_: boolean): void => {
    setOpen(true);
  };

  const closePanelAndDropdown = (): void => {
    setOpen(false);
    closePanel();
  };

  const saveDealsSelectDataAndCloseDropdown = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    onSaveDealsSelectData();
    setOpen(false);
  };

  const dealsMultiSelectDataOrder = useMemo<string[]>(() => {
    const notSelectedDeals =
      dealsMultiSelectData
        ?.filter((deal) => !roadmapDealUuids.includes(deal.key as string))
        .map((deal) => deal.key as string) ?? [];

    return roadmapDealUuids.concat(notSelectedDeals);
  }, [dealsMultiSelectData, roadmapDealUuids]);

  return {
    dealsMultiSelectDataOrder,
    open,
    onDropdownVisibleChange,
    closePanelAndDropdown,
    saveDealsSelectDataAndCloseDropdown,
  };
};
